import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { moments, interests } from '../data/resumeData';
import './ArchiveView.css';

const categoryColors = {
  recognition: 'var(--accent-leadership)',
  impact: 'var(--accent-enterprise)',
  milestone: 'var(--accent-primary)',
  launch: 'var(--accent-technical)',
  education: 'var(--text-secondary)',
};

export default function ArchiveView() {
  const [selectedMoment, setSelectedMoment] = useState(null);
  
  // Sort moments by year (most recent first)
  const sortedMoments = [...moments].sort((a, b) => parseInt(b.year) - parseInt(a.year));
  
  return (
    <div className="archive-view">
      <motion.div 
        className="archive-view__header"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <h2 className="archive-view__title">Archive</h2>
        <p className="archive-view__subtitle">Moments that shaped the journey</p>
      </motion.div>
      
      <div className="archive-view__timeline">
        {sortedMoments.map((moment, index) => (
          <motion.div
            key={moment.id}
            className={`archive-view__moment ${selectedMoment === moment.id ? 'archive-view__moment--selected' : ''}`}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            onClick={() => setSelectedMoment(selectedMoment === moment.id ? null : moment.id)}
            layoutId={`moment-${moment.id}`}
          >
            <div 
              className="archive-view__moment-marker"
              style={{ background: categoryColors[moment.category] }}
            />
            
            <div className="archive-view__moment-content">
              <div className="archive-view__moment-header">
                <span className="archive-view__moment-year">{moment.year}</span>
                <span 
                  className="archive-view__moment-category"
                  style={{ color: categoryColors[moment.category] }}
                >
                  {moment.category}
                </span>
              </div>
              
              <h3 className="archive-view__moment-title">{moment.title}</h3>
              <span className="archive-view__moment-subtitle">{moment.subtitle}</span>
              
              <AnimatePresence>
                {selectedMoment === moment.id && (
                  <motion.p
                    className="archive-view__moment-description"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    {moment.description}
                  </motion.p>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        ))}
        
        <div className="archive-view__timeline-line" />
      </div>
      
      {/* Beyond Work - Personal Interests Section */}
      <motion.div 
        className="archive-view__beyond"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        <div className="archive-view__beyond-header">
          <span className="archive-view__beyond-label">Beyond Work</span>
          <div className="archive-view__beyond-line" />
        </div>
        
        <div className="archive-view__interests">
          {interests.map((interest, index) => (
            <motion.div
              key={interest.id}
              className="archive-view__interest"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.7 + index * 0.1 }}
              whileHover={{ y: -2 }}
            >
              <span className="archive-view__interest-icon">{interest.icon}</span>
              <div className="archive-view__interest-content">
                <h4 className="archive-view__interest-title">{interest.title}</h4>
                <p className="archive-view__interest-description">{interest.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
